const routes = [
    {
        path: '/school/category/list',
        component: function () {
            return import('@/components/admin/school/Category')
        }
    },
    {
        path: '/school/category/save',
        component: function () {
            return import('@/components/admin/school/CategoryDetail')
        }
    },
    {
        path: '/school/class/list',
        component: function () {
            return import('@/components/admin/school/Class')
        }
    },
    {
        path: '/school/class/save',
        component: function () {
            return import('@/components/admin/school/ClassDetail')
        }
    },
    {
        path: '/school/ad',
        component: function () {
            return import('@/components/admin/school/Ad')
        }
    },
    {
        path: '/school/banner/ad',
        component: function () {
            return import('@/components/admin/school/BannerAd')
        }
    },
    {
        path: '/school/banner/detail',
        component: function () {
            return import('@/components/admin/school/BannerDetail')
        }
    },
    {
        path: '/school/hstj',
        component: function () {
            return import('@/components/admin/school/Hstj')
        }
    },
    {
        path: '/school/hstj/detail',
        component: function () {
            return import('@/components/admin/school/HstjDetail')
        }
    }
]

export default routes
